import React from "react"

const Button = (props) => {
  return (
    <button {...props} style={{ background: '#1b6aff', ...props.style }}>
      {props.children}
    </button>
  );
}

export default Button;